import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { ClipboardModule } from 'ngx-clipboard';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { UiCopyButtonModule } from '@unico-people/shared/dashboard/ui-copy-button';
import { UtilsMapModule } from '@unico-people/shared/utils/pipes/utils-map';
import { UtilsAccentsModule } from '@unico-people/shared/utils/pipes/utils-accents';
import { SalaryCollaboratorModule } from '../salary-collaborator/salary-collaborator.module';

// import { AllListModule } from '@app/core/_shared/components/all-list/all-list.module';

import { DadosColaboradorReadComponent } from './read/dados-colaborador.component';
import { DadosColaboradorUpdateComponent } from './update/dados-colaborador.component';

@NgModule({
  exports: [DadosColaboradorReadComponent, DadosColaboradorUpdateComponent],
  declarations: [DadosColaboradorReadComponent, DadosColaboradorUpdateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    UtilsMapModule,
    UtilsAccentsModule,
    SalaryCollaboratorModule,
    CurrencyMaskModule,
    ClipboardModule,
    UiCopyButtonModule
    // AllListModule,
  ]
})
export class DadosColaboradorModule {}
